export const PROGRESSION_MODEL_SLIDER_STEPS = 9;

// 30m intervals over a 4hr horizon
export const PROGRESSION_MODEL_FILL_COLORS: Record<number, string> = {
  0: '#A750FF', // 0min
  1: '#B34DE1', // 30min
  2: '#BF4BC4', // 60min
  3: '#CB48A6', // 90min
  4: '#D74689', // 120min
  5: '#E3436B', // 150min
  6: '#EF404D', // 180min
  7: '#FB3D2F', // 210min
  8: '#FF3A10', // 240min
};

export const PROGRESSION_MODEL_DEFAULT_COLOR = PROGRESSION_MODEL_FILL_COLORS[0];
